// libs
import React from 'react';

// hooks
import { useRemoteConfig } from 'shared/store/remoteConfigs/hooks';

// components
import PlainWidget from './components/PlainWidget';
import AttributeWidget from './components/AttributeWidget';
import ParentWidget from './components/ParentWidget';

// constants
import { WIDGET_TYPES } from 'shared/layouts/DetailsPage/components/ProductInfo/components/ProductDescription/constants';
import { KNOW_YOUR_PRODUCT_TITLE } from 'shared/layouts/DetailsPage/constants';

// types
import { IWidget } from 'shared/layouts/DetailsPage/components/ProductInfo/components/ProductDescription/types';

interface ICollapsibleContent {
  widget: IWidget;
}

function CollapsibleContent({ widget }: ICollapsibleContent) {
  const themeName = useRemoteConfig('themeName');
  const forceWhiteText = themeName === 'dark' && widget.title === KNOW_YOUR_PRODUCT_TITLE;

  const getWidgetComponent = (widget_data: IWidget) => {
    const type = widget_data.widget_type;

    switch (type) {
      case WIDGET_TYPES.parentWidget:
        return <ParentWidget widget={widget} />;

      case WIDGET_TYPES.plainCollapsableWidget:
        return <PlainWidget widget={widget} showTitle={false} forceWhiteText={forceWhiteText}></PlainWidget>;

      case WIDGET_TYPES.attributeWidget:
        return <AttributeWidget widget={widget} />;
    }
  };
  return <>{getWidgetComponent(widget)}</>;
}

export default CollapsibleContent;
